// extracted by mini-css-extract-plugin
export default {"fullWidth":"fullWidth___U3klu_contentrenderer","waitrose-image":"waitrose-image"};